import store from '@/store'

export default [
  {
    path: '/admin/positions',
    name: 'position',
    meta: { requiresAuth: true },
    component: () => import('@/pages/employee/position')
  }
]
